import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { loginUser } from "../../actions/authActions";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import "./signup.css";
import "../../assets/css/modal.css";

const SignupComplete = ({ show, closeModal, business_id, location_id, joinus, signup_login, user_name, loginUser, tempSignupResults }) => {
  const history = useHistory();
  const handleLogin = () => {
    closeModal();
    if (joinus) {
      window.location.href = "/?business_id=" + business_id + "&location_id=" + location_id
    } else if (business_id && location_id) {
      history.push("/?business_id=" + business_id + "&location_id=" + location_id);
    } else {
      history.push("/?business_id=" + localStorage.business_id + "&location_id=" + localStorage.location_id);
    }

    // console.log(signup_login, 'signup_loginwertywertyu')
    // if (signup_login) {
    //   const userData = {
    //     email: signup_login.user.email,
    //     password: tempSignupResults?.password || "test123",
    //     platform: "Food-Delivery",
    //     business_id: business_id,
    //     username: user_name
    //   }
    //   loginUser(userData, true, "register");
    // }
  }

  return (
    <Modal
      show={show}
      onHide={() => closeModal}
      dialogClassName="sc-dialog"
      contentClassName="sc-content"
      centered
    >
      <Modal.Body className="sc-body">
        <ModalCloseButton
          onClick={() => { joinus ? (window.location.href = "/?business_id=" + business_id + "&location_id=" + location_id) : closeModal(); }}
        />

        <div className="sc-icon-ring">
          <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <div className="sc-heading">GREAT!</div>
        <p className="sc-subtext">
          Your account has been created successfully. Thank you for choosing to dine with us!
        </p>
      </Modal.Body>

      <Modal.Footer className="sc-footer">
        <button
          type="button"
          className="sc-cta-btn"
          onClick={handleLogin}
        >
          START ORDERING NOW!
        </button>
        <div className="sc-powered">Powered by Warely</div>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  tempSignupResults: state?.user?.tempSignup
});

export default connect(mapStateToProps, { loginUser })(SignupComplete);